<div class="main-dashboard">
  <div class="top">
    <div class="time">{{ currentDate }}</div>
  </div>
  <div class="heading">
    <div class="title">{{'Dashboard' | translate}}</div>
  </div>

  <div class="main-widget">
    <ng-container *ngFor="let module of modules; let i = index">
      <div class="widget" *ngIf="module.access">
        <div class="content">
          <div class="bound">
            <div class="avatar">
              <div [class]="module.class"></div>
            </div>
            <div class="text">
              <div class="title">{{module.title | translate}}</div>
              <!-- <div class="description">{{module.description | translate}}</div> -->
            </div>
          </div>
          <div class="foot">
            <div class="btn-go" (click)="onGo(module, i)" *ngIf="module.link; else noLink">
              {{'Go' | translate}}
              <div class="forward"></div>
            </div>
            <ng-template #noLink>
              <div class="btn-go">
                {{'Go' | translate}}
                <div class="forward"></div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- <div class="user-tips">
    <div class="title">{{'User tips' | translate}}</div>
    <div class="tips">
      <div class="col__">
        <div class="map-view">
          <div class="map"></div>
          <div class="text">
            <div class="title"><span class="bold">{{'Map' | translate}}</span>{{'View' | translate}}</div>
            <div class="description">{{'Description' | translate}}</div>
          </div>
        </div>
      </div>
      <div class="col__">
        <div class="mobile">
          <div class="image"></div>
          <div class="text">
            <div class="title">{{'LogChain on Mobile' | translate}}</div>
            <div class="description">{{'Description' | translate}}</div>
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <div class="soon">
    <div class="title">{{'Soon on LogChain' | translate}}</div>
    <div class="content">
      <img src="/assets/images/illustration/background-truck.png" width="100%" height="auto"
        style="border-radius: 3px;" />
      <div class="text">
        <div class="title">{{'Welcome to our New Global Partner' | translate}}</div>
        <div class="description">
          "The Port of Hong Kong recorded its biggest increase in activity since October 2017 - Vietnam, business
          destination for all entrepreneurs - The Port of Hong Kong recorded its biggest increase in activity since
          October 2017 - Vietnam, business destination for all entrepreneur - Vietnam, business destination for all
          entrepreneurs - The Port of Hong Kong recorded its biggest increase in activity since October 2017 - Vietnam,
          business destination for all entrepreneur ...
        </div>
        <a href="https://thelogchain.com/" target="_blank" class="btn btn-primary link" role="button" style="width: 290px; margin-top: 50px;">{{'Visit Website' | translate}}</a>
      </div>
    </div>
  </div>

  <!-- <div class="update-logchain">
    <div class="content">
      <div class="head">Update LogChain</div>
      <div class="description">Your Software is updated. Next update in 3 days...</div>
      <div class="version">Current Version : 1.6.2</div>
      <img src="/assets/images/illustration/laptop.svg" width="315px" height="auto" style="margin: auto;" />
      <button disabled class="btn btn-primary" style="width: 290px; margin: auto; margin-top: 50px;">Verify my Software</button>
    </div>
  </div> -->
</div>
